import React from 'react';
import { domainUrl,rootDomainUrl } from '../config/Config';
import { getUserData, reactLoader, getTokenData, clearUserData, headerLoad, monthNames ,message } from '../helpers/Common';
import { isMatchesEmail, isValidEmail, handleFormErrors } from '../helpers/Fields';
import { Username } from '../helpers/User';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getInbox } from '../actions/inboxAction';
import { getProfile } from '../actions/profileAction';
import DmWall from '../partials/DmWall';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
const $ = window.$;
class Header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lr_pho: <img src={process.env.PUBLIC_URL + '/images/avathar.gif'} className="user-photo" width="50" />,
			message: 0,
			fnHideCorporateIDs: getUserData('fnHideCorporateIDs', true)
		};
		this.props.getInbox();
		this.props.getProfile();
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.profile.corp != undefined) {
			this.setState({
				message: nextProps.message,
				lr_pho: (nextProps.profile.corp.photo == '') ? <img src={process.env.PUBLIC_URL + '/images/avathar.gif'} className="user-photo" width="50" /> : nextProps.profile.corp.photo
			});
		}
	}
	userLogin(e) {
		e.stopPropagation();
		var selname=e.target.value;

		const selectedIndex = e.target.options.selectedIndex; 
		let password=e.target.options[selectedIndex].getAttribute('data-key'); 
		let expired=e.target.options[selectedIndex].getAttribute('expired'); 
		if(expired==0)
		{
			message('Note!', "Sorry You'r login has expired", 'info');
			return false;
		}
		var authUser = selname;
		//var authPwd = "melanoleuca";
		var authPwd="";
		if (password !== "")
		{
			authPwd=password;
		}
		else
		{
			authPwd = "Vaccinium55x23";
		}
		
		if (authUser.trim() === "" || authPwd.trim() === "") {
			handleFormErrors({
				'authpwd': "Please enter your username and password"
			});
			//Common.message("Validation error occurred.", "Please enter your username and password", "error");
		} else {
			handleFormErrors({});
			Common.reactLoader("show", "Please wait...");
			if (isMatchesEmail(authUser)) {
				fetch(Config.domainUrl + "user/login", {
					method: "POST",
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						authuser: authUser,
						authpwd: authPwd
					})
				}).then((response) => response.json()).then((responseJson) => {
					Common.reactLoader("hide");
					if (responseJson.status === 0) {
						Common.message(responseJson.message, responseJson.errors, "error");
					} else {
						//Common.setUserData("user", JSON.stringify(responseJson.data));
						try {
							Common.setTokenData("token", responseJson.token);
							Common.setUserData("isLoggedIn", true);
							let date = new Date();
							date.setSeconds(date.getSeconds() + Config.sessExpire);
							Common.setUserData("sessMax", date.getTime());
							let decodeJson = Common.parseJwt(responseJson.token);
							setTimeout(() => {
								if (decodeJson.beforeRoutes.length > 0) {
									window.location.reload();
									//this.props.router.push(decodeJson.beforeRoutes[0].url);
								} else if (decodeJson.afterRoutes.length > 0) {
									this.props.router.push(decodeJson.afterRoutes[0].url);
								} else {
									//this.props.router.push(decodeJson.routePath);
									window.location.reload();
								}
							}, 500);
						}
						catch (e) {
							alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
							this.props.router.goBack();
						}
					}
				});
			} else {
				fetch(Config.rootDomainUrl + "imeta/includes/metaajax_control.php?q=metalogin&name=" + authUser + "&pword=" + authPwd, {
					method: "GET",
				}).then((response) => response.json()).then((responseJson) => {
					Common.reactLoader("hide");
					if (responseJson === "Sucess") {
						window.location.href = Config.rootDomainUrl + "home.php";
					} else {
						Common.message("Validation error occurred.", "Username (or) password incorrect.", "error");
					}
				});
			}
		}
	}
	userLogout() {
		let productid_forredirect = getUserData('productID', true);
		reactLoader("show", "please wait...");
		fetch(domainUrl + "user/logout", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + getTokenData()
			},
			body: JSON.stringify({
				data: getTokenData()
			})
		}).then((response) => response.json()).then((responseJson) => {
			reactLoader("hide");
			if (responseJson.status != 0) {
				clearUserData();
				//window.location.href = window.location + "/#/login";
				if(productid_forredirect==429 || productid_forredirect==430)
				{
					window.location.assign("https://www.361dm.com/kluniversity.php");
				}
				else if(productid_forredirect===422)
				{
					window.location.assign("https://www.361dm.com/gndu.php");
				}
				else
				{
					window.location = window.location.origin;
				}
				
			}
		});
	}
	getLearnerWall() {
		document.body.className = 'dm-wall-open';
		this.refs.dmwall.loadWallData();
	}
	componentDidMount() {
		setTimeout(() => {
			headerLoad();
			$(".fancybox").fancybox({
				'href': '#poup-txt4', afterClose: function () {
					document.body.className = document.body.className.replace("dm-wall-open", "");
				}
			});
			$(".popup").hide();
		}, 100);
	}
	switchPanel() {
		$(".leftposstatic").css('display', 'block');
		this.props.switchPanel();
	}
	menuHandleChange(type) {
		this.props.menuClick(type);
	}

	goToHome(){
		window.location.reload(true);
	}
	render() {
		let messages = this.state.message;
		let productName = getUserData('productName', true);
		let productid = getUserData('productID', true);
		let corporateID = getUserData('corporateID', true);
		let product_logo= getUserData('product_logo', true);
		let tech_logo= getUserData('tchnology_partnerlogo', true);
		let multiple_product= getUserData('multiple_product', true);
		let checkif_loginexpired= getUserData('chk_ifanyissuein_login', true);
		let multiple_usernames= getUserData('multiple_usernames', true);
		let username = getUserData('primaryEmail', true);
		let badge = (messages != 0) ? "badge1" : "";
		let d = new Date();
		let jDate = d.getDate();
		let jMonth = monthNames[d.getMonth()];
		let jYear = d.getFullYear();
		let is_careerlauncher = getUserData('is_careerlauncher', true);
		let styles = {marginLeft: '208px'}
		let key ="key";
		//console.log(multiple_usernames);
		return (
		<div className="headerwhite">
			
			<header className="fixed-head">  
			{( username == 'rkarthikhrm@361dm.com')?
			<marquee direction="right">
			<p className="lr-title">Please visit library for information regarding free courses</p>
			</marquee>:'' }
				<div className="logo"><a onClick={()=> this.goToHome()} href="javascript:void(0);">
				{/* {(corporateID==60) ?
					<img src={process.env.PUBLIC_URL + '/images/Technology_partner_final.png'}  alt="361&deg;minds&trade;" title="361&deg;minds&trade;" />
					: '' }
					{(productid==429 || productid==430) ?
					<img src={process.env.PUBLIC_URL + '/images/KL_UNIVERSITY_LOGO.png'}  alt="361&deg;minds&trade;" title="361&deg;minds&trade;" />
					: '' }
					{(productid!=429 && productid!=430 && corporateID!=60) ?
					<img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="361&deg;minds&trade;" title="361&deg;minds&trade;" />
					: ''} */}
					{(tech_logo== '') ? <img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="361&deg;minds&trade;" title="361&deg;minds&trade;" /> : <img src={rootDomainUrl+'/admin/upload_images/'+tech_logo} alt="361&deg;minds&trade;" title="361&deg;minds&trade;" /> }
					
					 </a></div>
					 {(product_logo=='') ? '' : <div className="logo"><a href="javascript:void(0);"><img src={ rootDomainUrl+'/admin/upload_images/'+product_logo} alt="361&deg;minds&trade;" height="60" style={styles} title="IDIADA-HR" /> </a></div> }
				{/* {(productid==416)?  <div className="logo"><a onClick={()=> this.goToHome()} href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/LogoIDIADA_RGB_White.jpg'} alt="361&deg;minds&trade;" height="60" style={styles} title="IDIADA-HR" /> </a></div> : ''}
				{(productid==417)?  <div className="logo"><a onClick={()=> this.goToHome()} href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/gujarat_logo.png'} alt="361&deg;minds&trade;" height="60" style={styles} title="Guj-Chetna" /> </a></div> : ''}
				{(productid==420)?  <div className="logo"><a onClick={()=> this.goToHome()} href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/madras_university3.png'} alt="361&deg;minds&trade;" style={styles} title="Madras University" /> </a></div> : ''}
				{(productid==422)?  <div className="logo"><a onClick={()=> this.goToHome()} href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/guru_nanak.jpg'} alt="361&deg;minds&trade;" style={styles} title="Guru NANAK DEV UNIVERSITY" /> </a></div> : ''}
				{(productid==415 || productid==414 || productid==413 || productid==320 || productid==303 || productid==302 || productid==301 || productid==300 || productid==299 || productid==298 || productid==297 || productid==296)?  
				<div className="logo"><a href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/TNAU-01.png'} alt="361&deg;minds&trade;" height="60" style={styles} title="TNAU" /> </a></div> : ''}
				{(productid==429) ? <div className="logo"><a href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/BCA.png'} alt="361&deg;minds&trade;" height="60" style={styles} title="TNAU" /> </a></div>
				:
				 '' }
				{(productid==430) ? <div className="logo"><a href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/MBA.png'} alt="361&deg;minds&trade;" height="60" style={styles} title="TNAU" /> </a></div>
				:
				 '' } */}

				{this.state.fnHideCorporateIDs === false &&
					<div className="top-links">
						<ul>
							{/* {(corporateID!=77) && (corporateID!=78) ?
							<li className="wall">
								<select name="multiple_products" id="multiple_products" onChange={this.userLogin}>
								<option disabled>Programs</option>
								 {multiple_product.map((value,index) => (
									 multiple_usernames[index] == username ?
									 <option value={multiple_usernames[index]} data-key={multiple_usernames.passwords[index]} expired={checkif_loginexpired[index]} selected>{value}</option>
								:  	<option value={multiple_usernames[index]} data-key={multiple_usernames.passwords[index]} expired={checkif_loginexpired[index]}>{value}</option>
								 ))} 
								</select></li> : ''} */}

								
							{!is_careerlauncher && (productid !=418 && productid !=419 && corporateID!=77 && corporateID!=93) ?
							<li className="wall" onClick={() => this.getLearnerWall()}>
							<a href="javascript:void(0);" title="361dm wall" className="fancybox show" ><span>361dm</span>wall</a>
							</li> : ''
							}
							{(corporateID!=77) ?
							<li className="program">
								<span><a href="javascript:void(0);"> <img src={process.env.PUBLIC_URL + '/images/pgm-icon.png'} alt="Program" title="Program" border="0" /></a></span>
								<div className="hover-arrow"></div>
								<div className="pgm-name"><center>{productName}</center></div>
							</li>: ''
							}
							<li className="date"><span>{jDate}</span> {jMonth}</li>
							{!is_careerlauncher && (productid!=418 && productid!=419 && corporateID!=77 && corporateID!=93) ?
							<li className={"message " + badge} data-badge={(this.state.message != 0) ? this.state.message : ''} onClick={e => this.menuHandleChange('messages')}><a href="javascript:void(0);"> <img src={process.env.PUBLIC_URL + '/images/img-message.png'} alt="Message" title="Message" border="0" /> </a> 
							</li> : ''}	
							{(corporateID!=77) ?
							<li className="user">
								<a href="javascript:void(0);">
									{/* <img src="images/avathar.gif" title="Upload \ Edit Photo" className="user-photo" width="50" /> */}
									<span dangerouslySetInnerHTML={{ __html: this.state.lr_pho }} />
								</a>
								<div className="hover-arrow"></div>
								<div className="usr-name"> {Username()}</div>
							</li>
							: ''}	
							<li className="others">
								<a href="javascript:void(0);"><img src={process.env.PUBLIC_URL + '/images/other-lnks.png'} alt="" border="0" /></a>
								<div className="details">
									<div className="user-arrow"></div>
									<ul>
									{(corporateID!=77) ?
										<li><a href="javascript:void(0);" onClick={() => this.goToHome()} >Home</a></li>
										: ''}	
										{(!is_careerlauncher && corporateID!=77 && corporateID!=93) ? <li><a href="javascript:void(0);" onClick={e => this.menuHandleChange('my_profile')}>My Profile</a></li> : ''}
										
										<li><a href="javascript:void(0);" onClick={(e) => this.userLogout(e)}>Logout</a></li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				}
			</header>
			<div id="poup-txt4" className="popup" style={{ display: "none" }}>
				<DmWall ref="dmwall" autoload={false} />
			</div>
		</div>);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		message: state.inbox.unread,
		profile: state.profile
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ getInbox, getProfile }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/partials/Header.js